<script lang="ts">
  /**
   * "Schedule send" menu (spec §11): `schedLater` (+3 h), `schedTomorrow` (08:00), `schedWeek`
   * (+7 d 08:00) from `store.scheduleOptions()`; picking one sends immediately with `sendAt`.
   */
  import { t } from '$lib/i18n';
  import { store } from '$lib/store';
  import { focusTrap, menuKeys } from '$lib/util/dom';

  let { id, onpick, onclose }: { id: string; onpick: (at: number) => void; onclose: () => void } = $props();

  const options = store.scheduleOptions();

  function onKey(ev: KeyboardEvent): void {
    if (ev.key !== 'Escape') return;
    ev.preventDefault();
    ev.stopPropagation();
    onclose();
  }
</script>

<div class="sched-menu" role="menu" tabindex="-1" {id} use:menuKeys use:focusTrap onkeydown={onKey}>
  {#each options as opt (opt.key)}
    <button type="button" class="sched-opt" role="menuitem" data-key={opt.key} onclick={() => onpick(opt.at)}>{t(opt.key)}</button>
  {/each}
</div>

<style>
  /* ===== component: svelte-lveo7m (Compose) — schedule menu rules ===== */
  .sched-menu {
    position: absolute;
    inset-block-start: 100%;
    inset-inline-end: var(--space-4);
    z-index: var(--z-layer);
    display: flex;
    flex-direction: column;
    background: var(--surface-card);
    border: 1px solid var(--border-default);
    border-radius: var(--radius-md);
    box-shadow: var(--shadow-md);
    overflow: hidden;
  }

  .sched-opt {
    border: 0;
    background: none;
    color: var(--text-body);
    padding: var(--space-3) var(--space-5);
    text-align: start;
    font: inherit;
    cursor: pointer;
    white-space: nowrap;
  }

  .sched-opt:hover {
    background: var(--surface-subtle);
  }

  .sched-opt:active {
    background: var(--surface-sunken);
  }
</style>
